import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { localizedPath } from "@/lib/url-slugs";

const SaleBanner = () => {
  const { lang } = useLanguage();
  
  const text = {
    lv: { sale: "IZPĀRDOŠANA!", upto: "LĪDZ", off: "ATLAIDE IZVĒLĒTĀM PRECĒM!" },
    en: { sale: "SALE!", upto: "UP TO", off: "OFF ON SELECTED ITEMS!" },
  };

  const t = text[lang];

  return (
    <Link to={localizedPath(lang, "sale")} className="block w-full bg-accent hover:brightness-110 transition-all cursor-pointer">
      <div className="container mx-auto flex items-center justify-center h-10 px-4 gap-1.5 md:gap-2 text-center">
        <span className="font-display font-bold text-accent-foreground text-xs md:text-sm tracking-wide">{t.sale}</span>
        <span className="text-accent-foreground/80 text-[10px] md:text-xs font-medium">{t.upto}</span>
        <span className="font-display font-black text-accent-foreground text-sm md:text-base leading-none">-40%</span>
        <span className="text-accent-foreground/80 text-[10px] md:text-xs font-medium">{t.off}</span>
      </div>
    </Link>
  );
};

export default SaleBanner;
